import type { MappedLocation } from 'shared';

/**
 * Label for a mapped city/airport for the active UI language.
 *
 * Recent searches and similar snapshots store every `name_*` field, but the
 * generic `name` field reflects the locale at save time only — it does not
 * update when the user switches app language (unlike vue-i18n copy).
 */
export const getLocalizedMappedLocationLabel = (
  location: MappedLocation | undefined,
  locale: string,
): string => {
  if (!location) {
    return '';
  }
  const lang = locale.split('-')[0];
  if (lang === 'kk') {
    return location.name_kk || location.name;
  }
  if (lang === 'en') {
    return location.name_en || location.name;
  }
  return location.name_ru || location.name;
};
